<button mat-raised-button (click)="descarcaPDFBtnClick()"  >
  <mat-icon aria-hidden="false" aria-label="Descarca Document"> cloud_download</mat-icon>

</button>
